import { BaseService } from './BaseService';
import { JornadaDto } from '../types';

/**
 * DTO para actualizar una jornada
 */
export interface UpdateJornadaDto {
  equipoRival: string;
}

/**
 * Servicio para gestionar jornadas
 */
class JornadaService extends BaseService {
  constructor() {
    super('/jornadas');
  }

  /**
   * Obtiene todas las jornadas de un equipo
   * @param equipoId ID del equipo
   * @returns Promise con las jornadas del equipo
   */
  async obtenerJornadasPorEquipo(equipoId: number): Promise<JornadaDto[]> {
    const response = await this.get<JornadaDto[]>(`equipo/${equipoId}`);
    return response.data;
  }

  /**
   * Obtiene una jornada específica por ID
   * @param jornadaId ID de la jornada
   * @returns Promise con la jornada
   */
  async obtenerJornadaPorId(jornadaId: number): Promise<JornadaDto> {
    const response = await this.getById<JornadaDto>(jornadaId);
    return response.data;
  }

  /**
   * Actualiza el equipo rival de una jornada
   * @param jornadaId ID de la jornada
   * @param equipoRival Nombre del equipo rival
   * @returns Promise con la jornada actualizada
   */
  async actualizarEquipoRival(jornadaId: number, equipoRival: string): Promise<JornadaDto> {
    const response = await this.update<JornadaDto>(jornadaId, { equipoRival });
    return response.data;
  }
}

// Exportar instancia del servicio
export const jornadaService = new JornadaService();
export default JornadaService;